import { deleteSessionCookie } from "@/mixins/Cookies";
import { authGuard, useAuth0 } from "@auth0/auth0-vue";
import { createRouter, createWebHistory } from "vue-router";
import store from "../state/index.js";

const AccountDashboard = () => import("@/views/AccountDashboard.vue");
const AccountProfile = () => import("@/views/AccountProfile.vue");
const EmailSubscriptions = () => import("@/views/EmailSubscriptions.vue");
const ErrorPage = () => import("@/views/ErrorPage.vue");
const EventsIndex = () => import("@/views/EventsIndex.vue");
const FocalArea = () => import("@/views/FocalArea.vue");
const HelpPage = () => import("@/views/HelpPage.vue");
const NotAuthorized = () => import("@/views/NotAuthorized.vue");

const routes = [
  {
    path: "/account-profile",
    name: "Account Profile",
    component: AccountProfile,
    beforeEnter: authGuard,
    meta: {
      showDashboardNav: true,
    },
  },
  {
    path: "/email-subscriptions",
    name: "Email Subscriptions",
    component: EmailSubscriptions,
    beforeEnter: authGuard,
    meta: {
      showDashboardNav: true,
    },
  },
  {
    path: "/error",
    name: "Error",
    component: ErrorPage,
  },
  {
    path: "/webinars-and-events",
    name: "Events Index",
    component: EventsIndex,
    beforeEnter: authGuard,
    meta: {
      showDashboardNav: true,
    },
  },
  {
    path: "/focal-area/:slug",
    name: "Focal Area",
    component: FocalArea,
    beforeEnter: authGuard,
    meta: {
      showDashboardNav: true,
      requiresFocalAreaAccess: true,
    },
  },
  {
    path: "/help",
    name: "Help",
    beforeEnter: authGuard,
    component: HelpPage,
    meta: {
      showDashboardNav: true,
    },
  },
  {
    path: "/not-authorized",
    name: "Not Authorized",
    component: NotAuthorized,
  },
  {
    path: "/",
    name: "Account Dashboard",
    beforeEnter: authGuard,
    component: AccountDashboard,
    meta: {
      showDashboardNav: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Account Dashboard",
    component: AccountDashboard,
    beforeEnter: authGuard,
    meta: {
      showDashboardNav: true,
    },
  },
  // Redirects
  {
    path: "/project-groups",
    redirect: "/",
  },
  {
    path: "/sign-in",
    alias: "/log-in",
    name: "Sign In",
    redirect: "/",
  },

  {
    path: "/log-out",
    alias: "/sign-out",
    name: "Log Out",
    beforeEnter: async () => {
      await logout();
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export async function logout() {
  deleteSessionCookie();

  store.commit("app/updateUserAuthorized", false);
  store.commit("app/updateUserAuthenticated", false);
  store.commit("app/dataPulled", false);

  await useAuth0().logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
}

router.afterEach((to) => {
  if (to.name !== "Error" && to.name !== "Not Authorized") {
    if (store.state.app.errorOccurred) {
      store.commit("app/updateErrorOccurred", true);
    }
  }

  const showDashboardNav = to.matched.some(
    (record) => record.meta.showDashboardNav,
  );

  if (store.state.app.mobileNavVisible) {
    setTimeout(() => {
      store.commit("app/updateMobileNavVisible", false);
    }, 300);
  }

  if (showDashboardNav) {
    store.commit("app/updateShowDashboardNav", true);
  } else {
    store.commit("app/updateShowDashboardNav", false);
  }
});

export default router;
